
import {useStore} from "@/store";
import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
interface State {
    configInfo: object[];
    baseInfo:  object[];
    batterySystemInfo:  object[];
    photoList:  object[];
    templateCode: string;
}
export default defineComponent({
        name: "promiseFrame",
        setup() {
            let state: State = reactive({
                configInfo: [],
                baseInfo: [],
                batterySystemInfo: [],
                photoList: [],
                templateCode: ''
            })
            document.title='电池管理系统信息';
            window.scrollTo(0,0);
            // let carInfo = localStorage.getItem('carInfo') || '';
            // console.log(carInfo);
            // state.configInfo = JSON.parse(carInfo).configureInfos;
            // state.baseInfo = JSON.parse(carInfo).basicItemInfos;
            let store = useStore()
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {componentList} = JSON.parse(JSON.stringify(data));
                const batterySystemInfo = componentList.find(item => item.code === 'batterySystemInfo');
                state.batterySystemInfo = batterySystemInfo && batterySystemInfo.configItems;
            }, {immediate: true, deep: true})
            return {
                state
            }
        },
        components: {
        },
        beforeUnmount () {
            localStorage.removeItem('carInfo');
        },
    })
